<template>
  <div class="input-locale-container">
    <div class="input-locale-content">
      <component
        :is="component"
        v-for="(locale, key) in locales"
        :key="key"
        :value="formattedValue[key]"
        :label="getLabel(locale)"
        :name="`${name}.${key}`"
        v-bind="props"
        class="is-flex-grow-1"
        @input="onInput($event, key)"
      />
    </div>
  </div>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator () {
        return true; // Accept anything
      }
    },
    locales: {
      default () {
        return this.$laravel.app.locales;
      },
      type: Object
    },
    component: {
      default () {
        return "v-input";
      },
      type: String
    },
    props: {
      default () {
        return {};
      },
      type: Object
    }
  },
  computed: {
    formattedValue () {
      let value = _.isPlainObject(this.value) ? this.value : {};
      Object.keys(this.locales).forEach(locale => {
        if (!Object.prototype.hasOwnProperty.call(this.value, locale)) {
          value[locale] = "";
        }
      });
      return value;
    }
  },
  methods: {
    getLabel (locale) {
      if (Object.keys(this.locales).length > 1) {
        return `${this.label} (${locale})`;
      }
      return this.label;
    },
    onInput (value, locale) {
      let formattedValue = this.formattedValue;
      formattedValue[locale] = value;
      return formattedValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-locale-container {
  margin-bottom: 1.5rem;
}

.input-locale-content {
  display: flex;
  flex-wrap: wrap;
  margin: -0.75rem;

  .field {
    margin-bottom: 0;
  }

  & > * {
    padding: 0.75rem;
    margin: 0;
  }
}
</style>
